import { SprinklerFireIcon } from './SprinklerFireIcon';

/**
 * author: Michael Irigoyen
 * id ECE05EC2-192B-4450-A0CB-78249EC9140A
 * name sprinkler-fire
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sprinkler-fire.svg
 * tags
 * - Home Automation 
 * - Agriculture 
 */
export const SprinklerHeadIcon = SprinklerFireIcon;
export default SprinklerHeadIcon